module.exports = __webpack_public_path__ + "static/media/deaths-fury.2d339071.png";